import { ARDOQ_DEFAULT_LOCALE } from './locales';
import { getLocale } from './utils';

export const getDefaultLocale = (language: string = navigator.language) => {
  return getLocale(language) ?? ARDOQ_DEFAULT_LOCALE;
};
